<template>
  <div class="ui dimmer modals page" :class="{active: show, visible: show}" @click="onDimmer">
    <div :class="sizeClass" class="ui visible active modal" v-show="show">
      <i @click="close" class="close icon"></i>
      <div class="header">
        <slot name="title">
          {{ title }}
        </slot>
      </div>
      <div class="content">
        <slot></slot>
      </div>
      <div class="actions">
        <slot name="actions">
          <div @click="onCancel" class="ui cancel button">{{cancelText}}</div>
          <div @click="onSubmit" class="ui positive button">{{okText}}</div>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Modal',
    model: {
      prop: 'open',
      event: 'changed'
    },
    props: {
      open: {
        type: Boolean,
        default: false
      },
      title: {
        type: String,
        default: ''
      },
      size: {
        type: String,
        default: ''
      },
      okText: {
        type: String,
        default: '确认'
      },
      cancelText: {
        type: String,
        default: '取消'
      },
    },
    data() {
      return {
        show: false,
      };
    },
    computed: {
      sizeClass() {
        return {
          [this.size]: true
        };
      }
    },
    watch: {
      open(newValue) {
        this.show = newValue;
      }
    },
    methods: {
      close() {
        this.show = false;
        this.$emit('changed', false);
      },
      onDimmer(event) {
        if (this.show && event.target === event.currentTarget) {
          this.close();
        }
      },
      onSubmit() {
        this.$emit('submit');
        this.close();
      },
      onCancel() {
        this.$emit('cancel');
        this.close();
      }
    }
  };
</script>

<style scoped>

</style>
